export const WIGGLE_AMPLITUDE = 5;
export const WIGGLE_TIME_FREQ = 2.5;
export const WIGGLE_SPATIAL_FREQ = 0.25;

// Lightweight 1D coherent noise via layered sine harmonics (no dependencies).
// Returns roughly in [-1, 1].
export function noise1D(x) {
  return Math.sin(x * 1.0) * 0.5
       + Math.sin(x * 2.3 + 1.7) * 0.3
       + Math.sin(x * 4.1 + 3.1) * 0.2;
}

// Quadratic midpoint smoothing: produces a smooth SVG path `d` string from
// an array of {x, y} points. Each interior point becomes a quadratic control
// point with the midpoint to the next point as the on-curve point.
export function pointsToSmoothPath(pts) {
  if (pts.length === 0) return '';
  if (pts.length === 1) {
    return `M ${pts[0].x} ${pts[0].y} L ${pts[0].x + 0.1} ${pts[0].y}`;
  }
  let d = `M ${pts[0].x} ${pts[0].y}`;
  for (let i = 1; i < pts.length - 1; i++) {
    const mx = (pts[i].x + pts[i + 1].x) / 2;
    const my = (pts[i].y + pts[i + 1].y) / 2;
    d += ` Q ${pts[i].x} ${pts[i].y} ${mx} ${my}`;
  }
  const last = pts[pts.length - 1];
  d += ` L ${last.x} ${last.y}`;
  return d;
}
